import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { HeaderProgressTracker } from '../../Common/HeaderStepper/HeaderProgressTracker';
import * as Steps from './steps/index';
import { saveSessionEvent } from "../../../session";
import { SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY, setSessionStorageItem, getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import '../TermReview/TermReview.scss'
import { httpRequest } from '../../../httpRequest';

export default function PermReview(props) {

    useEffect(() => { saveSessionEvent() }, [props.location])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    const path = props.location ? props.location.pathname.split("/").pop() : null;
    const allFormState = getSessionStorageItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY);

    const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    let newFormState = {
        currentStep: 1,
        pages: {
            primaryInsuredInfo: Steps.PrimaryInsuredInfo.DefaultFormState(prefill),
            existingPolicyInformation: Steps.ExistingPolicyInformation.DefaultFormState(prefill),
            agentInformation: Steps.AgentInformation.DefaultFormState(prefill),
            inforceLedger: Steps.InForceLedger.DefaultFormState(prefill),
            fileUpload: Steps.FileUpload.DefaultFormState(prefill),
            submit: Steps.Submit.DefaultFormState(),
        },
    }

    const initialFormState = allFormState || newFormState;

    const [formState, setFormState] = useState(initialFormState);

    useEffect(() => {

        if (!path) {
            return;
        }

        let nextStep = steps.find((s) => s.path === path);

        if (!nextStep) {
            const newPath = props.location ? props.location.pathname.split("/").slice(-2) : null;
            if (!newPath) {
                return;
            }

            nextStep = steps.find((s) => s.path === newPath[0]);
            if (!nextStep) {
                return;
            }
        }
        const newFormState = { ...formState, currentStep: nextStep.step };
        setFormState(newFormState);
    }, [path]);

    const onNext = () => {
        let nextStep = steps.find((s) => s.step === formState.currentStep + 1);
        if(nextStep.path ==='file-upload' && formState.pages.inforceLedger.inForceLedgerType==='inforceLedgerNeeded'){
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if(nextStep.path ==='agent-information' && formState.pages.inforceLedger.inForceLedgerType==='inforceLedgerNeeded'){
            nextStep = steps.find((s) => s.step === nextStep.step + 1);
        }
        if (!nextStep) {
            throw new Error('onNext did not find a next step');
        }

        const newFormState = { ...formState, currentStep: nextStep.step };

        setFormState(newFormState);
        setSessionStorageItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY, newFormState);

        props.history.push(`/Quote/PermReview/${nextStep.path}`);
        window.scroll(0, 0);
    };

    const onBack = () => {
        let backStep = steps.find(s => s.step === formState.currentStep - 1);
       
        if (backStep) {
            if(backStep.path ==='file-upload' && formState.pages.inforceLedger.inForceLedgerType ==='inforceLedgerNeeded'){
                backStep = steps.find((s) => s.step === backStep.step - 1);
            }
            if(backStep.path ==='agent-information' && formState.pages.inforceLedger.inForceLedgerType ==='inforceLedgerNeeded'){
                backStep = steps.find((s) => s.step === backStep.step - 1);
            }
            const newFormState = { ...formState, currentStep: backStep.step };

            setFormState(newFormState);
            setSessionStorageItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY, newFormState);

            props.history.push(`/Quote/PermReview/${backStep.path}`);
            window.scroll(0, 0);

        }
        else {
            props.history.push('/ResourceCenter');
            props.setActiveLink(props.navLinks.findIndex((a) => a.text === 'Resource Center'));
        }
    };

    const onFieldChange = (step, field, value) => {
        setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
    }

    const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
        let stepPer = ((step - 1) / totalStep * 100);
        let cateCount = currentCateTotalStep === 1 ? 1 : (((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep));
        return (stepPer + cateCount);
    }

    const clearFormState = () => {
        sessionStorage.removeItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY);
        setFormState(newFormState);
        props.history.push('/policyReview');
    }

    const clearAllSession = () =>{
        let newFormState = formState;
        newFormState.pages.primaryInsuredInfo = Steps.PrimaryInsuredInfo.DefaultFormState(prefill);
        newFormState.pages.agentInformation = Steps.AgentInformation.DefaultFormState(prefill);
        newFormState.pages.existingPolicyInformation = Steps.ExistingPolicyInformation.DefaultFormState(prefill);
        newFormState.pages.fileUpload = Steps.FileUpload.DefaultFormState(prefill);
        newFormState.pages.submit = Steps.Submit.DefaultFormState(prefill);
        setFormState({ ...newFormState });
    }

    const submitRequest =()=>{
        setLoading(true);
        setError("");

        if (formState.pages.submit.policyReviewId === '') {
            const dataFromSession = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
            const fileObj = {
                file : formState.pages.fileUpload.file.fileList
            }
            const requestData = {
                policyType: 'PERM',
                oneClickAccountID: dataFromSession.account.oneClickAccountId,
                accountName: dataFromSession.account.accountName,
                pages: {
                    inForceLedger: formState.pages.inforceLedger,
                    primaryInsuredInfo: formState.pages.primaryInsuredInfo,
                    existingPolicyInformation: formState.pages.existingPolicyInformation,
                    agentInformation: formState.pages.agentInformation,
                    fileUpload:fileObj
                },
            }
            httpRequest.post(`api/Case/SubmitPolicyReview`, requestData)
                .then((data) => {
                    if(data.success){
                        let newFormState = { ...formState}
                        newFormState.pages.submit.policyReviewId = String(data.content.newID)
                        setFormState(newFormState);
                        setSessionStorageItem(SESSION_STORAGE_PERM_REVIEW_OBJECT_KEY, newFormState);
                        onNext();
                    }
                    else{
                        setError("Failed to submit your policy review.") 
                    }
                    setLoading(false)
                }).catch(error => {
                    setLoading(false)
                    setError("Failed to submit your policy review.")
                })
        }
        else {
            setLoading(false)
            onNext();
        }
    }

    const steps = [
        {
            step: 1,
            path: 'inforce-ledger',
            progressTitle: 'Inforce Ledger Type',
            component: (
                <Steps.InForceLedger
                    formState={formState.pages.inforceLedger}
                    onFieldChange={(field, value) => onFieldChange('inforceLedger', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    clearAllSession ={clearAllSession}
                />
            ),
            categoryNumber: 1,
            categoryStep: 1,
        },
        {
            step: 2,
            path: 'file-upload',
            progressTitle: 'File Upload',
            component: (
              <Steps.FileUpload
                formState={formState.pages.fileUpload}
                onFieldChange={(field, value) => onFieldChange('fileUpload', field, value)}
                onNext={onNext}
                onBack={onBack}
                onMultiFieldChange={(fs) => {
                  setFormState(fs);
                }}
                fullFormState={formState}
              />
            ),
            categoryNumber: 2,
            categoryStep: 1,
          },
        {
            step: 3,
            path: 'primary-insured-info',
            progressTitle: 'Primary Insured Info',
            component: (
                <Steps.PrimaryInsuredInfo
                    formState={formState.pages.primaryInsuredInfo}
                    onFieldChange={(field, value) => onFieldChange('primaryInsuredInfo', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    ageSpecs={{ min: 0, max: 124 }}
                    fullFormState = {formState}
                />
            ),
            categoryNumber: 2,
            categoryStep: 2,
        },
        {
            step: 4,
            path: 'existing-policy',
            progressTitle: 'Existing Policy Info',
            component: (
                <Steps.ExistingPolicyInformation
                    formState={formState.pages.existingPolicyInformation}
                    onFieldChange={(field, value) => onFieldChange('existingPolicyInformation', field, value)}
                    onNext={onNext}
                    onBack={onBack}
                    fullFormState={formState}
                    onMultiFieldChange={(fs) => {
                        setFormState(fs);
                    }}
                    submitRequest={submitRequest}
                    loading = {loading}
                    error = {error}
                />
            ),
            categoryNumber: 3,
            categoryStep: 1,
        },
        {
            step: 5,
            path: 'agent-information',
            progressTitle: 'Your Information',
            component: (
                <Steps.AgentInformation
                    formState={formState.pages.agentInformation}
                    onFieldChange={(field, value) => onFieldChange('agentInformation', field, value)}
                    onBack={onBack}
                    submitRequest={submitRequest}
                    loading = {loading}
                    error = {error}
                />
            ),
            categoryNumber: 3,
            categoryStep: 2,
        },
        {
            step: 6,
            path: 'complete',
            progressTitle: 'Complete',
            component: (
                <Steps.Submit
                    clearFormState={clearFormState}
                    fullFormState={formState}
                    formState = {formState.pages.submit}
                />
            ),
            categoryNumber: 3,
            lastStep: true
        },
    ];

    const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
    const categories = steps.filter((o) => o.categoryNumber === currentStepObj.categoryNumber);
    const totalCategoriesStep = Math.max.apply(Math, categories.map(function (o) { return o.categoryStep; }))

    const percent = calculatePercentage(3, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
    return (
        <div>
            <Helmet>
                <title>Covr Advisor - {currentStepObj.progressTitle} </title>
            </Helmet>

            <HeaderProgressTracker breadcrumbLink={[{ name: 'INSURANCE TOOLS', href: '/ResourceCenter' },{ name: 'POLICY REVIEW', href: '/policyReview' }]} headerProductsText={true} displayStepTitleWithArrow={true} currentPage={true} showContainer={false} hideProgressTracker={false} title="Perm Policy Review" stepName={currentStepObj.progressTitle} step={currentStepObj.categoryNumber} categoryStep={currentStepObj.categoryStep} path={currentStepObj.path} totalSteps={3} lastStep={currentStepObj.lastStep} percent={percent}>
                <div className="Term-Review">
                    {currentStepObj.component}
                </div>
            </HeaderProgressTracker>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/PolicyReview/PermReview/PermReview.js